// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "a3cd006e",
    "hash": "a3cd006e",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "a3cd006e",
    "semverString": null,
    "version": "1.0.0"
};
/* tslint:enable */
